// import primary libraries
import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Link } from 'react-router-dom';

// import css modules
import landingStyles from '../landingStyles.css';

//build and export the landing page Hero banner
class Hero extends React.Component{
  constructor(props){
    super(props);
  }

  render(){
    return (
      <div className="wrapper">
        <div className="overlay">
          <h1>Pro-ficiency Application Portal</h1>
          <h3>Online Simulation Training for Clinical Trials</h3>
        </div>
      </div>
    )
  }
};

export default Hero;



// WEBPACK FOOTER //
// modules/static/components/LandingHero.js.jsx